<template>
    <div class="content">
        <ChannelOperator :channel="channel"/>
    </div>
</template>
<script>
import ChannelOperator from '@/views/international/channel/source/ChannelOperator.vue'
export default {
  data() {
    return {
      channel:'cmlink',
    }
  },
  components: {
    ChannelOperator
  },
  methods: {
    
  }
}
</script>